module.exports = __webpack_public_path__ + "html/pricing_dd224a00d491dfcb7fe023365807edb3.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio/pricing.html
// module id = v+R/
// module chunks = 151